import {
  getSessionStorageItem,
  OneTrustCategory,
  setLocalStorageItem,
  setSessionStorageItem,
} from '@square/onetrust-compliant-access';
import { ApplicationType } from '@squareup/dex-types-shared-application-type';
import {
  AccessTokenAction,
  ApiExplorerAccessTokenContext,
} from '@squareup/dex-ui-shared-api-explorer-providers';

const persistAccessToken = (token: string, env: ApplicationType) => {
  setSessionStorageItem(
    `api-explorer-access-token:${env.toLowerCase()}`,
    token,
    OneTrustCategory.FUNCTIONAL
  );
};

const persistEnvironment = (environment: ApplicationType) => {
  setLocalStorageItem(
    'api-explorer-environment',
    environment,
    OneTrustCategory.FUNCTIONAL
  );
};

const accessTokenReducer = (
  state: ApiExplorerAccessTokenContext,
  action: AccessTokenAction
) => {
  if (action.type === 'SET') {
    persistAccessToken(action.payload.token, action.payload.environment);
    persistEnvironment(action.payload.environment);

    return action.payload;
  } else if (action.type === 'SET_ENVIRONMENT') {
    const accessToken = getSessionStorageItem(
      `api-explorer-access-token:${action.payload.toLowerCase()}`
    ) as string;

    persistEnvironment(action.payload);
    return {
      environment: action.payload,
      token: accessToken,
      productionClient: '',
    };
  } else if (action.type === 'SET_TOKEN') {
    persistAccessToken(action.payload, state.environment);
    return { ...state, token: action.payload };
  } else if (action.type === 'SET_PRODUCTION_CLIENT') {
    return { ...state, productionClient: action.payload };
  } else {
    throw new Error(
      `Unknown action type: ${(action as { type: string }).type}`
    );
  }
};

export { accessTokenReducer };
